import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { iconRegistry } from '../../../common/icons';
const Icon = ({ name, className = '', style = {}, color, size }) => {
    const IconComponent = iconRegistry[name];
    if (!IconComponent)
        return null;
    const computedStyle = Object.assign(Object.assign(Object.assign({}, style), (color && { color })), (size && { fontSize: typeof size === 'number' ? `${size}rem` : size }));
    return _jsx(IconComponent, { className: className, style: computedStyle });
};
export default Icon;
